module.exports = __webpack_public_path__ + "static/img/tools_red.e7b2552b.svg";